"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BarBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "progress-bar__BarBox",
  componentId: "sc-1jondvi-0"
})(["border-radius:2px;"]);
var defaultProps = {
  barColor: "success"
};

var ProgressBar = function ProgressBar(_ref) {
  var barColor = _ref.barColor,
      progress = _ref.progress;
  return /*#__PURE__*/_react["default"].createElement(BarBox, {
    backgroundColor: "background-light",
    height: "4px",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(BarBox, {
    backgroundColor: barColor,
    height: "4px",
    progress: progress,
    width: progress
  }));
};

ProgressBar.propTypes = {
  barColor: _propTypes.string,
  progress: _propTypes.number
};
ProgressBar.defaultProps = defaultProps;
ProgressBar.displayName = "Modules.ProgressBar";
var _default = ProgressBar;
exports["default"] = _default;